import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TablePagination from '@mui/material/TablePagination';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import TableSortLabel from '@mui/material/TableSortLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import Grid from '@mui/material/Grid';
import pageimg from './images/attendance.png';
import moment from 'moment';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactToPrint from 'react-to-print';


const headCells = [
  { id: 'sr_studentname', numeric: false, label: 'Name' },
  { id: 'sa_schoolname', numeric: false, label: 'School' },
  { id: 'bc_title', numeric: false, label: 'Batch' },
  { id: 'str_score', numeric: false, label: 'Score' },
  { id: 'str_rank', numeric: false, label: 'Rank' },
  { id: 'str_percent', numeric: false, label: 'Percentage' },
  { id: 'sta_submitdate', numeric: false, label: 'Start Time' },
  { id: 'sta_submitdatemax', numeric: false, label: 'End Time' },
];

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, rowCount } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell key={headCell.id} sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const styles = {
  root: { width: '100%' },
  container: { maxHeight: 440 },
};

export default class StudentQuizResults extends Component {
  constructor(props) {
    super(props);
    const from = moment().startOf('month').toDate();
    const to = moment().toDate();
    const fformatted = moment(from).format('YYYY-MM-DD');
    const tformatted = moment(to).format('YYYY-MM-DD');

    this.state = {
      redirect: false,
      Branchdata: [],
      brancharray: [],
      Classarr: [],
      examarray: [],
      Yeararr: [],
      branch: localStorage.getItem('MMCbranchid') || '', 
      classid: '',
      exam: '',
      sr_studentname: '',
      page: 0,
      rowsPerPage: 50,
      rowsPaging: [50, 100, 150, 200, 250],
      totaldata: 0,
      order: 'desc',
      orderBy: 'str_score',yearlabel:'Select Year',
      yearid: localStorage.getItem('MMCyearid') || '',
      fdate1: fformatted,
      tdate1: tformatted,
    };
  }

  componentDidMount() {
    document.title = 'MM Coaching Center - Quiz Results';
    if (!localStorage.getItem('MMCuserid')) {
      this.setState({ redirect: true, pagename: '/Login' });
      return;
    }

    this.onloadbranchbind();
    this.ClassBind();
    this.YearBind();
    this.onloadexambind();
    //this.apicall(this.state.page, this.state.rowsPerPage);
  }

myChangeHandler = event => {
  const { name, value } = event.target;
  this.setState({ [name]: value }, () => {
    if ((name === 'branch' || name === 'classid') && this.state.branch && this.state.classid) {
      this.onloadexambind();
      this.setState({ exam: '' });
    }
  });
};

handleClickSearch = () => {
  this.setState({ page: 0 }, () => {
    this.apicall(0, this.state.rowsPerPage);
  });
};

handleChangePage = (event, newPage) => {
  this.setState({ page: newPage }, () => {
    this.apicall(newPage, this.state.rowsPerPage);
  });
};

handleChangeRowsPerPage = event => {
  const newRows = parseInt(event.target.value, 10);
  this.setState({ page: 0, rowsPerPage: newRows }, () => {
    this.apicall(0, newRows);
  });
};

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({ orderBy: property, order: isAsc ? 'desc' : 'asc' }, () => {
      this.apicall(this.state.page, this.state.rowsPerPage);
    });
  };

  onloadbranchbind() {
    axios.get(Serverurl + 'ajaxbranch.php?action=getall').then(response => {
      if (Array.isArray(response.data)) {
        const roleFromApi = response.data.map(branch => ({
          value: branch.br_id,
          display: branch.br_title,
        }));
        this.setState({ brancharray: [{ value: '', display: 'Select Branch' }, ...roleFromApi] });
      }
    });
  }

  ClassBind() {
    axios.get(Serverurl + 'ajaxtrustandclass.php?action=getall&tc_type=2').then(resp => {
      if (resp.data.length > 0) {
        const classFromApi = resp.data.map(row => ({
          value: row.tc_id,
          display: row.tc_title,
        }));
        this.setState({ Classarr: [{ value: '', display: 'Select Class' }, ...classFromApi] });
      }
    });
  }

  YearBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=3')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Yeararr:resp.data,yearid:localStorage.getItem("MMCyearid")	
							}) 
			}
		
		//this.BatchBind();
	   }) .then(data => {
        let yearFromApi = this.state.Yeararr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Yeararr: yearFromApi
        });
      })

}

onloadexambind() {
  const { branch, classid, yearid } = this.state;
  if (!branch || !classid) {
    this.setState({ examarray: [{ value: '', display: 'Select Exam' }], exam: '' });
    return;
  }
  axios.get(Serverurl + 'ajaxexam.php?action=getexambyclassbranch&br_id=' + branch + '&class_id=' + classid + '&year_id=' + yearid)
    .then(response => {
      if (Array.isArray(response.data)) {
        const examOptions = response.data.map(exam => ({ value: exam.ex_id, display: exam.ex_name }));
        this.setState({ examarray: [{ value: '', display: 'Select Exam' }, ...examOptions], exam: '' });
      } else {
        this.setState({ examarray: [{ value: '', display: 'Select Exam' }], exam: '' });
      }
    });
}

apicall(page, rowsPerPage) {
  const sorting = this.state.orderBy + ' ' + this.state.order;
  const startIndex = page * rowsPerPage;
  axios.get(Serverurl + 'ajaxresults.php?action=rankwisegetall'+ '&br_id=' + this.state.branch+ '&class_id='+this.state.classid+ '&ex_id=' + this.state.exam+ '&sr_studentname=' + this.state.sr_studentname+ '&StartIndex=' + startIndex + '&PageSize=' + rowsPerPage+ '&sorting=' + sorting+'&sa_year_id='+this.state.yearid)
  .then(resp => {
    if (Array.isArray(resp.data) && resp.data.length > 0) {
      this.setState({
        Branchdata: resp.data,
        totaldata: parseInt(resp.data[0].count)
      });
    } else {
      this.setState({ Branchdata: [], totaldata: 0 });
    }
  });
}

  render() {
    if (this.state.redirect) return <Navigate to={this.state.pagename} />;

    return (
      <React.Fragment>
        <div className="containermain">
          <div className="boxheading">
            <div className="contntpad">
              <h2>
                <img src={pageimg} alt="Exam" /> Quiz Results
              </h2>
            </div>
          </div>

          <div className="searchmaster">
            <ul>
              <li>
                <p>Student Name</p>
                <p>
                  <TextField
                    variant="outlined"
                    fullWidth
                    value={this.state.sr_studentname}
                    name="sr_studentname"
                    onChange={this.myChangeHandler}
                    placeholder="Enter Student Name"
                  />
                </p>
              </li>

			    <li>
                <p>Year</p>
                <p>
                  <FormControl fullWidth size="small">
                    <Select
                      native
                      name="yearid"
                      value={this.state.yearid}
                      onChange={this.myChangeHandler}
                    >
                      {this.state.Yeararr.map(row => (
                        <option key={row.value} value={row.value}>
                          {row.display}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </p>
  </li>

              <li>
                <p>Branch</p>
                <p>
                  <FormControl fullWidth size="small">
                    <Select
                      native
                      name="branch"
                      value={this.state.branch}
                      onChange={this.myChangeHandler}
                    >
                      {this.state.brancharray.map(b => (
                        <option key={b.value} value={b.value}>
                          {b.display}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </p>
              </li>

              <li>
                <p>Class</p>
                <p>
                  <FormControl fullWidth size="small">
                    <Select
                      native
                      name="classid"
                      value={this.state.classid}
                      onChange={this.myChangeHandler}
                    >
                      {this.state.Classarr.map(c => (
                        <option key={c.value} value={c.value}>
                          {c.display}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </p>
              </li>

              <li>
                <p>Exam</p>
                <p>
                  <FormControl fullWidth size="small">
                    <Select
                      native
                      name="exam"
                      value={this.state.exam}
                      onChange={this.myChangeHandler}
                    >
                      {this.state.examarray.map(e => (
                        <option key={e.value} value={e.value}>
                          {e.display}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </p>
              </li>

              <li>
                <p>
                  <Button
                    variant="contained"
                    onClick={this.handleClickSearch}
                    className="frmPrimarybtn"
                    endIcon={<SearchIcon />}
                  >
                    Search
                  </Button>
                  &nbsp;
                  <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="exportbtn"
                    table="quizresulttable"
                    filename="Quiz Results"
                    sheet="Quiz Results"
                    buttonText="Export"/>
                </p>
              </li>
            </ul>
          </div>
 <div ref={el => (this.componentRef = el)} >
          <Paper className={styles.root}>
            <TableContainer className={styles.container}>
              <Table id="quizresulttable" stickyHeader>
                <EnhancedTableHead
                  order={this.state.order}
                  orderBy={this.state.orderBy}
                  onRequestSort={this.handleRequestSort}
                  rowCount={this.state.Branchdata.length}
                />
                <TableBody>
                  {this.state.Branchdata.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.sr_studentname} ({row.sa_referenceno})</TableCell>
					  <TableCell>{row.sa_schoolname}</TableCell>
                      <TableCell>{row.bc_title}</TableCell>
                      <TableCell>{row.str_score}</TableCell>
                      <TableCell>{row.str_rank}</TableCell>
                      <TableCell>{row.str_percent}%</TableCell>                    
<TableCell>{row.sta_submitdate}</TableCell>
<TableCell>{row.sta_submitdatemax}</TableCell>
                    </TableRow>
                  ))}
                  {this.state.totaldata === 0 && (
                    <TableRow>
                      <TableCell align="center" colSpan={3}>
                        No Records
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
<TablePagination
  rowsPerPageOptions={this.state.rowsPaging}
  component="div"
  count={this.state.totaldata}
  rowsPerPage={this.state.rowsPerPage}
  page={this.state.page}
  onPageChange={this.handleChangePage}
  onRowsPerPageChange={this.handleChangeRowsPerPage}
/>

          </Paper></div>
        </div>
      </React.Fragment>
    );
  }
}
